import { dateFormat } from "helpers/common";
import colorRange from "Assets/images/colorRange.png";
import { Col, Row } from "react-bootstrap";
import TrackerRangeSlider from "../TrackerRangeSlider/Index";

const AnswerTracker = ({ answer, question }) => {
  const answerOtherDetails = answer?.answer?.other_details;

  const trackerLabels = question?.question_dd_labels?.tracker || [];
  console.log("answerOtherDetails", answerOtherDetails);

  // return early if tracker is not enabled
  // if(!answerOtherDetails?.visibility === "hidden") {
  //   return null;
  // }

  return (
    <>
      {answerOtherDetails?.tracking?.length > 0 &&  answerOtherDetails?.tracking?.map((answer, index) => {
        return (
          <div className="border rounded-3 p-3 mb-3" key={index}>
            <p className="m-0 themeBlue">
              {dateFormat(answer.date_time, "DD-MM-YYYY hh:mm A","YYYY-MM-DDTHH:mm")}
            </p>
            <div className="py-3">
              <h6 className="m-0 fw-sbold themeBlue pb-1">Observations</h6>
              {answer.notes && (
                <p className="m-0 themeBlue pt-2">{answer.notes}</p>
              )}
            </div>
            <Row className="py-3">
              <Col lg="6">
                <div className="d-flex align-items-start flex-column justify-content-between gap-10 w-100">
                  <TrackerRangeSlider
                    labels={trackerLabels}
                    value={answer?.percentage || 0}
                  >
                    <input
                      value={answer?.percentage || 0}
                      id="frequency-range"
                      className="frequency-range"
                      type={"range"}
                      min="0"
                      max="100"
                      disabled={true}
                    />
                  </TrackerRangeSlider>
                  {/* <img
                    src={colorRange}
                    alt=""
                    className="img-fluid"
                  /> */}
                </div>
              </Col>
            </Row>
          </div>
        )
      })}
    </>
  )
}

export default AnswerTracker;